// Configuration de l'application
const appConfig = {
  version: '1.5.0',
  developer: 'Matthieu SIMAR',
  copyright: `© ${new Date().getFullYear()} Transcription AI`,
  appName: 'Transcription AI',
  description: 'Solution intelligente pour la transcription et le résumé de réunions'
};

export default appConfig; 